module.exports = __webpack_public_path__ + "img/4.85da1ca0.png";